<template>
  <div>
    <h1 class="text-center mb-3">Info om eiendom</h1>
    <v-card class="mt-4 mb-4">
      <v-toolbar color="accent" :dark="protocol.dark">
        <v-toolbar-side-icon>
          <v-icon>mdi-map-marker</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>Adresseinformasjon</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12 @click="addressDialog = true">
          <v-text-field
            outline
            label="Adresse"
            readonly
            append-icon="mdi-chevron-right"
            @click="addressDialog = true"
            :value="addressConcat"
            @change="updateFields"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            outline
            hide-details
            label="Matrikkel"
            @click="matrikkelDialog = true"
            :value="matrikkelConcat"
            @change="updateFields"
            readonly
            append-icon="mdi-chevron-right"
            :loading="matrikkelLoading"
          ></v-text-field>
        </v-flex>
      </v-card-text>
    </v-card>
    <v-card class="mt-4 mb-4">
      <v-toolbar color="accent" :dark="protocol.dark">
        <v-toolbar-side-icon>
          <v-icon>mdi-floor-plan</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>Størrelse</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                box
                label="BRA"
                type="number"
                suffix="m2"
                hide-details
                v-model="stepValues.size.bra"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                box
                label="BTA"
                type="number"
                suffix="m2"
                hide-details
                v-model="stepValues.size.bta"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                box
                label="P-rom"
                type="number"
                suffix="m2"
                hide-details
                v-model="stepValues.size.p"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                box
                label="Tomt"
                type="number"
                suffix="m2"
                hide-details
                v-model="stepValues.size.property"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-4 mb-4">
      <v-toolbar color="accent" :dark="protocol.dark">
        <v-toolbar-side-icon>
          <v-icon>mdi-calendar</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>Byggeår</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                box
                solo
                hide-details
                label="Byggeår"
                type="number"
                v-model="stepValues.year"
                @input="updateFields"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <StepButtons @next-page="next" @previous-page="previous" />
    <v-dialog v-model="addressDialog" max-width="600px" :dark="protocol.dark">
      <v-card>
        <v-card-title>
          <span class="headline">Adresse</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm8>
                <v-text-field
                  v-model="stepValues.address.street"
                  label="Gatenavn"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field
                  v-model="stepValues.address.streetNr"
                  label="Gatenr"
                  type="number"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field
                  v-model="stepValues.address.streetLetter"
                  label="Bokstav"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="stepValues.address.zipcode"
                  type="number"
                  label="Postnr"
                  @input="findCityName"
                ></v-text-field>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  v-model="stepValues.address.city"
                  :loading="cityLoading"
                  label="Sted"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="findMatrikkel">Lagre</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="matrikkelDialog" max-width="600px" :dark="protocol.dark">
      <v-card>
        <v-card-title>
          <span class="headline">Matrikkel</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="stepValues.matrikkel.knr"
                  type="number"
                  label="Kommunenr"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="stepValues.matrikkel.knavn"
                  label="Kommunenavn"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="stepValues.matrikkel.gnr"
                  type="number"
                  label="Gårdsnr"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="stepValues.matrikkel.bnr"
                  type="number"
                  label="Bruksnummer"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="stepValues.matrikkel.fnr"
                  label="Festenr"
                  type="number"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="stepValues.matrikkel.snr"
                  label="Seksjonsnr"
                  type="number"
                  @input="updateFields"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="matrikkelDialog = false">Lagre</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import step from "../../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      addressDialog: false,
      matrikkelDialog: false,
      matrikkelLoading: false,
      cityLoading: false
    };
  },
  computed: {
    addressConcat: {
      get() {
        if (
          this.stepValues.address.street == "" &&
          this.stepValues.address.zipcode == ""
        ) {
          return "";
        }
        return (
          this.stepValues.address.street +
          " " +
          this.stepValues.address.streetNr +
          ", " +
          this.stepValues.address.zipcode +
          " " +
          this.stepValues.address.city
        );
      }
    },
    matrikkelConcat: {
      get() {
        if (
          this.stepValues.matrikkel.gnr == "" &&
          this.stepValues.matrikkel.bnr == "" &&
          this.stepValues.matrikkel.knr == ""
        ) {
          return "";
        }
        return (
          "Gnr. " +
          this.stepValues.matrikkel.gnr +
          ", Bnr. " +
          this.stepValues.matrikkel.bnr +
          " i kommune " +
          this.stepValues.matrikkel.knavn
        );
      }
    }
  },
  methods: {
    findCityName() {
      this.updateFields();
      if (this.stepValues.address.zipcode.length == 4) {
        this.cityLoading = true;
        fetch(
          "https://ws.geonorge.no/adresser/v1/sok?postnummer=" +
            this.stepValues.address.zipcode +
            "&filtrer=adresser.poststed,adresser.kommunenummer&treffPerSide=1&side=0&asciiKompatibel=true"
        )
          .then(res => res.json())
          .then(res => {
            if (res.adresser.length > 0) {
              this.stepValues.address.city = res.adresser[0].poststed;
              this.stepValues.matrikkel.knr = res.adresser[0].kommunenummer;
            } else {
              this.cityLoading = false;
            }
          })
          .catch(err => {
            console.log(err);
            this.cityLoading = false;
          })
          .finally(() => (this.cityLoading = false));
      }
    },
    findMatrikkel() {
      this.addressDialog = false;
      if (
        this.stepValues.address.street != "" &&
        this.stepValues.address.streetNr != "" &&
        this.stepValues.address.zipcode != ""
      ) {
        this.matrikkelLoading = true;
        fetch(
          "https://ws.geonorge.no/adresser/v1/sok?adressenavn=" +
            this.stepValues.address.street +
            "&nummer=" +
            this.stepValues.address.streetNr +
            "&bokstav=" +
            this.stepValues.address.streetLetter +
            "&postnummer=" +
            this.stepValues.address.zipcode +
            "&treffPerSide=1&side=0&asciiKompatibel=true"
        )
          .then(res => res.json())
          .then(res => {
            if (res.adresser.length > 0) {
              this.stepValues.matrikkel.knr = res.adresser[0].kommunenummer;
              this.stepValues.matrikkel.knavn = res.adresser[0].kommunenavn;
              this.stepValues.matrikkel.bnr = res.adresser[0].bruksnummer;
              this.stepValues.matrikkel.gnr = res.adresser[0].gardsnummer;
              this.stepValues.matrikkel.fnr = res.adresser[0].festenummer;
              this.stepValues.matrikkel.snr = res.adresser[0].undernummer;
            } else {
              this.matrikkelLoading = false;
            }
          })
          .catch(err => {
            console.log(err);
            this.matrikkelLoading = false;
          })
          .finally(() => (this.matrikkelLoading = false));
      }
    }
  }
};
</script>